(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3MemberRoster', {
            templateUrl: 'app/club-admin/member-roster/member-roster.component.html',
            controller: MemberRosterComponent,
            bindings: {
                roster: '<',
                isLegacy: '<',
                expiresIn: '<'
            }
        });

    var noop = angular.noop,
        gettext = angular.identity,
        forEach = angular.forEach,
        isObject = angular.isObject;

    MemberRosterComponent.$inject = ['$scope', 'user', 'Club', 'Member', 'defaultMemberRosterPageSize', 'alert', 'clubAdminResources', 'DataSource', 'clubMembershipLevelType', 'confirm', 'memberRosterSearchPlaceholder', 'toggleFriend', 'removeLegendModal', 'renewLegendModal', 'gettextCatalog', 'expirationFilterList'];
    function MemberRosterComponent($scope, user, Club, Member, defaultMemberRosterPageSize, alert, resources, DataSource, clubMembershipLevelType, confirm, memberRosterSearchPlaceholder, toggleFriend, removeLegendModal, renewLegendModal, gettextCatalog, expirationFilterList) {
        // Variables
        var ctrl = this,
            translate = gettextCatalog.getString.bind(gettextCatalog),
            selected = new Set();

        // Properties
        ctrl.filter = { isActive: true, level: null, search: null, expiresIn: null, isPrimary: null, isAdmin: null };
        ctrl.membershipLevels = [clubMembershipLevelType.Gold, clubMembershipLevelType.Bronze, null];
        ctrl.placeholder = memberRosterSearchPlaceholder;
        ctrl.expirationFilterList = expirationFilterList;

        // Special Properties
        Object.defineProperty(ctrl, 'selectedCount', { get: getSelectedCount });
        Object.defineProperty(ctrl, 'allSelected', { get: getAllSelected, set: setAllSelected });
        Object.defineProperty(ctrl, 'credit', { get: getCredit });

        // Methods
        ctrl.$onInit = init;
        ctrl.sort = sort;
        ctrl.selectionChanged = selectionChanged;
        ctrl.canRenewOrUpgrade = canRenewOrUpgrade;
        ctrl.showRemoveLegend = showRemoveLegend;
        ctrl.showRenewLegend = showRenewLegend;
        ctrl.isLimitedClubAdmin = user.isLimitedClubAdmin;
        ctrl.isHandicapChair = user.isHandicapChair;

        // Actions
        ctrl.toggleFriend = toggleFriend;
        ctrl.renewOrUpgrade = renewOrUpgrade;
        ctrl.removeMembers = removeMembers;
        ctrl.toggleStatus = toggleStatus;

        // Class Name Methods
        ctrl.getColumnClass = getColumnClass;
        ctrl.getActionClass = getActionClass;
        ctrl.getStatusClass = getStatusClass;

        // Property Accessors - getSelectedCount, getAllSelected, setAllSelected, getCredit
        // Helpers - getData, filterWatchAction, createMembershipLevels

        ///////////////////////////////////////////

        // Methods
        function init() {
            ctrl.filter.expiresIn = ctrl.expiresIn;

            ctrl.dataSource = new DataSource({
                data: ctrl.roster,
                read: getData,
                filter: ctrl.filter,
                pageSize: defaultMemberRosterPageSize,
                params: {
                    id: ctrl.roster.clubId
                }
            });

            // Note: the filter change will not trigger a datasource refresh.  It has no change detection other than property setters.
            $scope.$watch('$ctrl.filter', filterWatchAction, true);
        }
        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? { field: field, dir: 'desc' } : null;
        }
        function selectionChanged(member) {
            selected[member.selected ? 'add' : 'delete'](member.clubMembershipId);
        }
        function showRemoveLegend() {
            removeLegendModal().result.catch(noop);
        }
        function showRenewLegend() {
            renewLegendModal().result.catch(noop);
        }

        function canRenewOrUpgrade(member) {
            var selectedCount = ctrl.selectedCount,
                expirationDate = member.expirationDate;
            if (selectedCount) return false;
            return !expirationDate || dayDiff(new Date(), expirationDate) <= 225;
        }


        // Actions
        function toggleStatus(member) {
            // Note: member == null means use the selected members
            
                var name = member && member.name,
                    isActive = ctrl.filter.isActive,
                    selectedCount = ctrl.selectedCount,
                    confirmMessage = member ?
                        isActive ? translate(resources.deactivateMemberConfirmation).format(name) : translate(resources.activateMemberConfirmation).format(name) :
                        isActive ? translate(resources.deactivateSelectedConfirmation).format(selectedCount) : translate(resources.activateSelectedConfirmation).format(selectedCount),
                    errorMessage = member ?
                        isActive ? translate(resources.deactivateMemberFailed).format(name) : translate(resources.activateMemberFailed).format(name) :
                        isActive ? translate(resources.deactivateSelectedFailed).format(selectedCount) : translate(resources.activateSelectedFailed).format(selectedCount),
                    clubMembershipIdList = member ? [member.clubMembershipId] : Array.from(selected);

                if(isActive)
                    confirm(confirmMessage).then(toggleStatus, noop);
            

            function toggleStatus() {
                Member.setStatus({ clubMembershipIdList: clubMembershipIdList, isActive: !isActive }, success, error, true);

                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(errorMessage);
                }
            }
        }

        function renewOrUpgrade(member) {
            // Note: member == null means use the selected members
            var name = member && member.name,
                credit = ctrl.credit,
                selectedCount = member ? 1 : ctrl.selectedCount,
                confirmMessage = member ? translate(resources.renewOrUpgradeMemberConfirmation).format(credit, name) : translate(resources.renewOrUpgradeSelectedConfirmation).format(selectedCount, credit),
                errorMessage = member ? translate(resources.renewOrUpgradeMemberFailed).format(name) : translate(resources.renewOrUpgradeSelectedFailed).format(selectedCount),
                clubMembershipIdList = member ? [member.clubMembershipId] : Array.from(selected);
        
            var selCount = member ? 1 : ctrl.selectedCount;            

            if (selCount === 1 && member.isRenewalDisabled && member.isPrimary) {
                alert.warn(resources.cannotRenewMemberDisabled);
            }
            else if (selCount === 1 && !member.isPrimary) {      // Secondary Inactive Member
                if (!member.isActive) {    // Secondary Inactive
                    confirmMessage = member.isPrimaryActive ? translate(resources.renewOrUpgradeInactiveSecondayWithActivePrimaryMemberConfirmation).format(credit, name) : translate(resources.renewOrUpgradeInactiveSecondayWithInactivePrimaryMemberConfirmation).format(credit, name);      // Base message on primary club active status
                    confirm(confirmMessage).then(renewOrUpgrade, noop);
                }
                else {    // Secondary Active                    
                    if (member.isPrimaryActive)
                        alert.warn(resources.cannotRenewMemberNotPrimary);
                    else
                        confirm(translate(resources.renewOrUpgradeInactiveSecondayWithInactivePrimaryMemberConfirmation).format(credit, name)).then(renewOrUpgrade, noop);
                }                                                   
            }                
            else {                
                confirm(confirmMessage).then(renewOrUpgrade, noop);                
            }

            function renewOrUpgrade() {
                Member.renewOrUpgrade({ clubMembershipIdList: clubMembershipIdList }, success, error, true);
                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(errorMessage);
                }
            }
        }

        function removeMembers(member) {

            var selCount = member ? 1 : ctrl.selectedCount;
            if (selCount === 1 && member.isRemoveDisabled) {
                alert.warn(resources.cannotRemoveMember);
            }
            else {

                // Note: member == null means use the selected members
                var name = member && member.name,
                    isLegacy = ctrl.isLegacy,
                    selectedCount = member ? 1 : ctrl.selectedCount,
                    confirmMessage = member ?
                        isLegacy ? translate(resources.deactivateMemberConfirmation).format(name) : translate(resources.removeMemberConfirmation).format(name) :
                        isLegacy ? translate(resources.deactivateSelectedConfirmation).format(selectedCount) : translate(resources.removeSelectedConfirmation).format(selectedCount),
                    errorMessage = member ?
                        isLegacy ? translate(resources.deactivateMemberFailed).format(name) : translate(resources.removeMemberFailed).format(name) :
                        isLegacy ? translate(resources.deactivateSelectedFailed).format(selectedCount) : translate(resources.removeSelectedFailed).format(selectedCount),
                    clubMembershipIdList = member ? [member.clubMembershipId] : Array.from(selected);

                confirm(confirmMessage).then(removeMembers, noop);
            }

            function removeMembers() {
                Member.removeMembers({ clubMembershipIdList: clubMembershipIdList }, success, error, true);
                function success() {
                    ctrl.dataSource.read();
                }
                function error() {
                    alert.error(errorMessage);
                }            
            }
        }

        // Class Name Methods
        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }
        function getActionClass(member) {
            //return member.level == clubMembershipLevelType.Gold ? 'fa-repeat' : 'fa-level-up';
            return 'fa-redo';
        }
        function getStatusClass(member) {
            member = isObject(member) && member || ctrl.dataSource.view[0]; // <=== the selectall row doesn't have a member.  
            //return member.isActive ? 'fa-ban' : 'fa-check';
            return member.isActive ? 'fa-ban' : null;
        }

        // Property Accessors
        function getSelectedCount() {
            return selected.size;
        }
        function getAllSelected() {
            return selected.size == ctrl.dataSource.view.length;
        }
        function setAllSelected(value) {
            forEach(ctrl.dataSource.view, setSelected);
            function setSelected(member) {
                selected[(member.selected = value) ? 'add' : 'delete'](member.clubMembershipId);
            }
        }
        function getCredit() {
            return ctrl.roster.credit;
        }

        // Helpers
        function getData(options) {
            return Club.getClubMemberRoster(options, success, error);

            function success(data) {
                ctrl.roster = data;
                selected.clear();
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.memberRosterRequestFailed);
            }
        }
        function filterWatchAction(newVal, oldVal) {
            if (oldVal != newVal)
                ctrl.dataSource.page = 1;
        }
        function dayDiff(from, to) {
            var oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
            return Math.round((to.getTime() - from.getTime()) / oneDay);
        }
    }
})();